module.exports = __webpack_public_path__ + "static/media/iconTransmission.04a8fa25.svg";